import { XbpmContext, NOT_AUTHORIZED } from '../../services';
var XbpmAuthService = /** @class */ (function () {
    function XbpmAuthService(authProvider) {
        var _this = this;
        this.authProvider = authProvider;
        this.login = function () {
            if (_this.authProvider) {
                _this.authProvider.login();
            }
        };
        this.logout = function () {
            if (_this.authProvider) {
                _this.authProvider.logout();
            }
        };
        this.httpRequestHandler = function (request) {
            return _this.authProvider ? _this.authProvider.httpRequestHandler(request) : Promise.resolve(request);
        };
        this.httpErrorHandler = function (error) {
            // console.log('httpErrorHandler', error.response.status);
            if (error.response.status === 401) {
                _this.context.emit(NOT_AUTHORIZED);
            }
            return _this.authProvider ? _this.authProvider.httpErrorHandler(error) : Promise.reject(error);
        };
        this.canAccess = function () {
            return _this.authProvider ? _this.authProvider.canAccess() : Promise.resolve(true);
        };
    }
    Object.defineProperty(XbpmAuthService.prototype, "user", {
        get: function () {
            return this.authProvider ? this.authProvider.user : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XbpmAuthService.prototype, "authorized", {
        get: function () {
            return this.authProvider ? this.authProvider.authorized : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XbpmAuthService.prototype, "context", {
        get: function () {
            return XbpmContext.getContext();
        },
        enumerable: true,
        configurable: true
    });
    return XbpmAuthService;
}());
export { XbpmAuthService };
//# sourceMappingURL=auth.service.js.map